"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: ", ";\n  line-height: 14px;\n  text-transform: uppercase;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 17px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 17px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 17px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 19px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 19px;\n  font-weight: ", ";\n  line-height: 23px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getDefaultColor = function getDefaultColor(props) {
  var color = (0, _versions.getColor)(props, 'text');
  return {
    text: color["default"]
  };
};

var BaseText = _styledComponents["default"].span(_templateObject(), ''
/* color: ${props => baseColors[props.color] || colors.text.default}; */
, function (props) {
  return _tokens.baseColors[props.color] || getDefaultColor(props).text;
}, _tokens.fonts.weight.normal, _tokens.fonts.family.text);

var StyledText = [];
exports.StyledText = StyledText;
StyledText[1] = BaseText.extend(_templateObject2(), _tokens.fonts.weight.light);
StyledText[2] = BaseText.extend(_templateObject3(), _tokens.fonts.weight.semiBold);
StyledText[3] = BaseText.extend(_templateObject4(), _tokens.fonts.weight.semiBold);
StyledText[4] = BaseText.extend(_templateObject5(), _tokens.fonts.weight.medium);
StyledText[5] = BaseText.extend(_templateObject6(), _tokens.fonts.weight.normal);
StyledText[6] = BaseText.extend(_templateObject7(), _tokens.fonts.weight.normal);

var Text = function Text(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var Component = StyledText[props.size] || StyledText[6];
  return _react["default"].createElement(Component, props, children);
};

Text.propTypes = {
  size: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),
  color: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array])
};
Text.defaultProps = {
  size: 1,
  children: null
};
Text.displayName = 'Text';

var _default = (0, _context.withVersion)(Text);

exports["default"] = _default;